import { useCallback, useLayoutEffect, useRef, useState } from 'react'
import { Constent, getCurrentYear, SEOTITLE } from '../../components/CommonFunction'

import {
  setUpcomingIpoType,
  setTypeUpcomingFilter,
  Components,
  getIpoLiveDataPage,
  setUpcomingIpoData,
  setUpcomingnext,
  setUpcomingprevious,
  startUpcomingLoading,
  stopUpcomingLoading,
  getIpoLiveDataWise,
  setUpcomingPaginationLink,
  setUpcomingPageSize,
  setUpcomingPageNo,
  ReactPaginate,
  useDispatch,
  useEffect,
  useSelector,
  icons,
  commonFunctions,
  useParams,
  useNavigate,
  useLocation
} from '../../utils/npm'

// const { IpoInnerList, Loader, Button, FilterTypesInner } = Components
import IpoInnerList from '../../components/IpoInnerList'
import FilterTypesInner from '../../components/FilterTypesInner'
import Loader from '../../components/Loader'
import { Footer } from '../../routes/MyRoutes'
import { setSearchIPO } from '../../store/slice/masterSlice'
import { FaSearch } from 'react-icons/fa'
import useDebounce from '../../hooks/useDebounce'
import BreadCrumb from '../../components/BreadCrumb'
const { removeLastNumberFromUrl, setPageParameter } = commonFunctions
const { FaChevronLeft, FaChevronRight } = icons
const UpcomingIpoPage = () => {

  const dispatch = useDispatch();
  const { isloading, searchIPO } = useSelector((state) => state.masterSlice);
  const navigate = useNavigate();
  const location = useLocation();

  const isFetched = useRef(false);
  const { category: categoryParams } = useParams()
  const prevCategory = useRef(null);

  const [searchText, setSearchText] = useState('');
  const [loading2, setLoading2] = useState(false)
  const [category, setCategory] = useState(localStorage.getItem('ipoCategory_upcoming') || '');

  const [metaData, setMetaData] = useState({
    title: "",
    description: "",
    keyword: `Upcoming Mainboard IPOs ${getCurrentYear()}, IPO dates, IPO price band, IPO GMP trends, new IPO list`
  });

  useEffect(() => {
    const getTitle = () => {
      if (categoryParams === "mainboard") {
        return `Upcoming Mainboard IPOs ${getCurrentYear()} | Dates, Price Bands & GMP Trends`;
      } else if (categoryParams === "sme") {
        return `Upcoming SME IPOs ${getCurrentYear()} | Dates, Price Bands & GMP Trends`;
      } else {
        return `Upcoming IPOs ${getCurrentYear()} | New IPO Listings | Mainline & SME`;
      }
    };

    const getDescription = () => {
      if (categoryParams === "mainboard") {
        return `Complete list of upcoming Mainboard IPOs with expected dates, price bands, Grey Market Premium (GMP), and expert analysis. Plan your IPO investments.`;
      } else if (categoryParams === "sme") {
        return "Complete list of upcoming SME IPOs with expected dates, price bands, Grey Market Premium (GMP), and expert analysis. Invest wisely.";
      } else {
        return "Complete list of IPOs with expected dates, price bands, Grey Market Premium (GMP), and expert analysis. Invest wisely.";
      }
    };

    setMetaData((prev) => ({
      ...prev,
      title: getTitle(),
      description: getDescription(),
    }));

  }, [categoryParams]);

  // const [metaData, setMetaData] = useState({
  //   title: "Upcoming IPO GMP | IPO Grey Market Premium | Apply IPO | Check Allotment Status",
  //   description: "IPO Trend provides IPO details, GMP alerts, live subscription data, and push notifications to help investors track and invest in upcoming IPOs.",
  //   keyword: 'GMP IPO, gmp website, IPO GMP, IPO Watch, IPO allotment status, IPO grey market, IPO GMP today, ipo gmp today (live)'
  // });

  const {
    UpcomingData,
    Upcomingipotype,
    Upcomingloading,
    Upcomingerror,
    upcomingPaginationLink,
    upcomingPageSize,
    upcomingPageNo,
    typeFilter
  } = useSelector(state => state.ipoUpcomingData)

  const getIpoLiveData = async (
    pageNo,
    pageSize,
    filterType,
    filterCategory,
    search
  ) => {

    dispatch(startUpcomingLoading())
    try {
      const response = await getIpoLiveDataPage(
        pageNo,
        pageSize,
        filterType?.toLowerCase(),
        filterCategory.toLowerCase(),
        search
      )
      const { results, next, previous, total_page } = response?.data || {}

      if (results?.length > 0) {
        dispatch(setUpcomingIpoData(results))
        dispatch(setUpcomingPageSize(total_page))
      } else {
        dispatch(setUpcomingIpoData([]))
        dispatch(setUpcomingPageSize(1))
      }

      if (next !== null) {
        let data = removeLastNumberFromUrl(next)
        dispatch(setUpcomingPaginationLink(data?.updatedUrl))
        // dispatch(setUpcomingPageNo(data?.pageNo - 1))
      } else if (previous !== null) {
        let data = removeLastNumberFromUrl(previous)
        dispatch(setUpcomingPaginationLink(data?.updatedUrl))
        // dispatch(setUpcomingPageNo(+data?.pageNo + 1))
      } else {
        dispatch(setUpcomingPaginationLink(''))
        dispatch(setUpcomingPageNo(1))
      }
    } catch (error) {
      dispatch(setUpcomingIpoData([]))
      dispatch(setUpcomingnext(''))
      dispatch(setUpcomingprevious(''))
    }
    dispatch(stopUpcomingLoading())
  }

  const handlePageChange = async ({ selected }) => {
    const pageNo = selected + 1
    dispatch(setUpcomingPageNo(pageNo))
    let url = setPageParameter(upcomingPaginationLink, pageNo)
    dispatch(startUpcomingLoading())
    try {
      const response = await getIpoLiveDataWise(url)
      const { results, next, previous } = response?.data || {}
      if (results?.length > 0) {
        dispatch(setUpcomingIpoData(results))
      } else {
        dispatch(setUpcomingIpoData([]))
      }
    } catch (error) {
      dispatch(setUpcomingIpoData([]))
    }
    window.scrollTo(0, 0)
    dispatch(stopUpcomingLoading())
  }

  // const handleFilterChange = filter => {
  //   dispatch(setUpcomingIpoType(filter.ipoName))
  //   dispatch(setTypeUpcomingFilter(filter.ipoType))
  //   getIpoLiveData(1, 30, filter.ipoType, 'upcoming', '')
  //   dispatch(setUpcomingPageNo(1))
  // }

  // // 1️⃣ Update category state when route changes
  // useLayoutEffect(() => {
  //   if (categoryParams) {
  //     setCategory(categoryParams);
  //     localStorage.setItem('ipoCategory_upcoming', categoryParams);
  //     dispatch(setTypeUpcomingFilter(categoryParams));

  //   }
  // }, [categoryParams]);

  // // 2️⃣ Fetch data only when the category updates
  // useEffect(() => {
  //   if (category) {
  //     dispatch(setUpcomingPageNo(1));
  //     dispatch(stopUpcomingLoading());
  //     dispatch(setUpcomingIpoType(category));
  //     dispatch(setTypeUpcomingFilter(category));
  //     prevCategory.current = category;
  //   }
  // }, [category]);

  // useEffect(() => {
  //   if (typeFilter && category) {
  //     getIpoLiveData(1, 30, category, 'upcoming', '');
  //   }
  // }, [typeFilter, category]);

  // const isFetched = useRef(false); // Track API call status

  const handleFilterChange = useCallback((filter) => {
    dispatch(setUpcomingIpoType(filter.ipoName));
    dispatch(setTypeUpcomingFilter(filter.ipoType));
    dispatch(setUpcomingPageNo(1));
    getIpoLiveData(1, 30, filter.ipoType, 'upcoming', '');
  }, [dispatch]);

  // 1️⃣ Update category state when route changes
  useLayoutEffect(() => {
    if (categoryParams) {
      setCategory(categoryParams);
      localStorage.setItem('ipoCategory_upcoming', categoryParams);
      dispatch(setTypeUpcomingFilter(categoryParams));
      isFetched.current = false; // Reset when category changes
    }
  }, [categoryParams, dispatch]);

  // 2️⃣ Fetch data only when the category updates
  useEffect(() => {
    if (category) {
      dispatch(setUpcomingPageNo(1));
      dispatch(stopUpcomingLoading());
      dispatch(setUpcomingIpoType(category));
    }
  }, [category, dispatch]);

  // Memoized function to fetch IPO data
  const fetchIpoData = useCallback(() => {
    if (typeFilter && category) {
      getIpoLiveData(1, 30, typeFilter, 'upcoming', '');
      // Set to true to prevent multiple calls
    }
  }, [typeFilter, category]);

  // 3️⃣ Fetch data when filter or category changes (only once)
  useEffect(() => {
    fetchIpoData();
  }, [fetchIpoData]);


  // ------------------------------------------ Serarch -----------------------------------------------

  const handleSearchChange = (e) => {
    // setSearchText(e.target.value);
    dispatch(setSearchIPO(e.target.value));
  };

  const debounce = useDebounce(searchIPO, Constent?.SEARCH_DELAY);
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (searchIPO !== '') {
      getIpoLiveData(1, 30, Upcomingipotype, 'upcoming', searchIPO)
    } else {
      // getIpoLiveData(1, 30, Upcomingipotype, 'upcoming', '')
    }
  }, [debounce]);

  const handleSearchSubmit = async e => {
    e.preventDefault()
    dispatch(setSearchIPO(searchIPO));
  }


  return (
    <>

      <SEOTITLE title={metaData?.title} description={metaData?.description} keyword={metaData?.keyword} />

      <section>
        <div className='container'>

          <BreadCrumb title={'IPO List'} header={'IPO List'} subHeaderOnlyView={'IPO List'} />
          <h2 className="common_heading_h2 font-bold text-center brokerPage CurrentIPO">Upcoming IPO</h2>
          <div className='pb-3 lg:pb-4 innerFilterType ms-auto'>
            <FilterTypesInner
              onFilterChange={handleFilterChange} // Callback to handle filter changes
              selectedFilter={{
                ipoType: Upcomingipotype,
                ipoName: Upcomingipotype
              }} // Pass current filter value from Redux
            />
          </div>
          <div className='search_box relative pb-5 mb-5'>
            <form
              action=''
              className='search_form flex justify-end'
              onSubmit={handleSearchSubmit}
            >
              <input
                type='text'
                className='search_box'
                value={searchIPO}
                placeholder='Search IPO Here.'
                onChange={handleSearchChange}
              />
              <button className={`Search_magni cursor-pointer `}>
                {loading2 ? (
                  'Searching...'
                ) : (
                  <FaSearch className='text-white' />
                )}
              </button>
            </form>
          </div>
          <div>
            {Upcomingloading ? (
              <div className='flex justify-center pb-10'>
                <Loader />
              </div>
            ) : (
              <IpoInnerList data={UpcomingData} ipoCategory='upcoming' />
            )}

            {Upcomingerror && <p className='text-danger'>{Upcomingerror}</p>}

            {upcomingPageSize > 1 && (
              <>
                <ReactPaginate
                  previousLabel={<FaChevronLeft />}
                  nextLabel={<FaChevronRight />}
                  breakLabel={'...'}
                  pageCount={upcomingPageSize}
                  marginPagesDisplayed={5}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  forcePage={upcomingPageNo - 1}
                />
              </>
            )}
          </div>
        </div>
      </section>
      <Footer />

    </>)
}

export default UpcomingIpoPage
